import Vue from 'vue';
import UserService from './user.service';

const getDefaultItem = () => ({
    id: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
});

const user = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', JSON.parse(JSON.stringify(getDefaultState().item)));
            Vue.set(state, 'list', JSON.parse(JSON.stringify(getDefaultState().list)));
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await UserService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await UserService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await UserService.get(id);
            context.commit('update', data);
            return data;
        },
        async getUsersByDepartment(context, department) {
            if (department == null) department = 1;
            const { data } = await UserService.getUsersByDepartment(department);
            return data;
        },
        async getAllUsersByDepartment(context, department) {
            if (department == null) department = 1;
            const { data } = await UserService.getAllUsersByDepartment(department);
            return data;
        },
        async query(context, params) {
            const { data } = await UserService.query(params);
            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            const { data } = await UserService.delete(slug);
            context.commit('updateList', data);
            return data;
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default user;
